import { buildFacetDesignOverrideLite, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import {
  FDBodyText, FDHeadlineText,
} from '@facet-wealth/design';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { Disclosure } from 'Views/FreemiumEntry/HasRelationship/Content/Components/Disclosure';


export const fqResponseInsightReferralIntroMetaOverrideSet = buildFacetDesignOverrideLite()
  .nameOverride('insightTitle', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly)

  .nameOverride('insightDescription', {
    _component: () => Richtext,
    _customProps: {
      Component: FDBodyText,
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride(['disclosure', 'generalDisclosure', 'formDisclosure'], {
    _component: () => Disclosure,
  }, overrideReadOnly);
